import Inheritable from '@nxsys/components/Inheritable';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Switch } from 'antd';
import React from 'react';
import type { PayrollFinanceSectionProps } from './types';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { IRELAND } from '@nxsys/store/constants/keys';

const PayslipSettingSection: React.FC<PayrollFinanceSectionProps> = ({
  form,
  watchValues,
  visibility,
}) => {
  const { messages } = useTypedIntl();
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);
  const isIreland = payrollCountry === IRELAND;

  if (!visibility.payslipSetting) return null;

  return (
    <div className="pt-6">
      <div className="mb-6 text-xl font-medium text-gray-800">
        {messages['common.payslipSetting']}
      </div>
      <Form.Item
        name={['payslipSetting', 'showHPEntitlement']}
        wrapperCol={{ span: 24 }}
      >
        <Inheritable<boolean>
          label={messages['common.showHolidayPayEntitlement'] as string}
          name={['payslipSetting', 'showHPEntitlement']}
          value={watchValues?.payslipSetting?.showHPEntitlement}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
      {/* NX-5228: only the UK umbrella self-bill templates read this flag; the
          Irish payslip templates never render holiday-pay employer costs. */}
      {!isIreland && (
        <Form.Item
          name={['payslipSetting', 'showHPEmployerCostsYTD']}
          wrapperCol={{ span: 24 }}
        >
          <Inheritable<boolean>
            label={messages['common.showHolidayPayEmployerCostsYTD'] as string}
            name={['payslipSetting', 'showHPEmployerCostsYTD']}
            value={watchValues?.payslipSetting?.showHPEmployerCostsYTD}
            inheritedValue={false}
            form={form}
          >
            {({ value, onChange, disabled }) => (
              <Switch
                checked={value ?? false}
                disabled={disabled}
                onChange={onChange}
              />
            )}
          </Inheritable>
        </Form.Item>
      )}
    </div>
  );
};

export default PayslipSettingSection;
